module.exports = __webpack_public_path__ + "static/media/AutomaticPlaytesting.b10d0825.md";